import array from '@mailobj-browser/front/js/utils/array.js'
import contract from '@mailobj-browser/front/js/contracts/contract.js'
import form from "./form.js";
import links from "./links.js";
import scrollToEnd from "./scrollToEnd.js";

export default contract({
  form: array([
    form
  ]),
  links: array([
    links
  ]),
  scrollToEnd: array([
    scrollToEnd
  ]),
})